import script from "./role_mismatch_screen.vue?vue&type=script&setup=true&lang=js"
export * from "./role_mismatch_screen.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__